<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <b-col style="display: flex;
  flex-flow: column;
  height: 100%; padding: 0">
        <b-row style=" flex-grow : 1; margin: 0px">
            <a :href="tosText" target="_blank" style="display: none" ref="to_tos"></a>
            <hide-at breakpoint="small">
            <b-col md="4" style="box-shadow: 5px 0 5px -4px #333; z-index: 1;">
                <md-card class="md-dynamic-height" style="box-shadow: none">
                    <md-card-header>
                        <div class="md-title">Mangel melden</div>
                    </md-card-header>

                    <md-card-content>
                        <form autocomplete="on">
                            <md-field :class="titleError">
                                <label>Titel</label>
                                <md-input v-model="title" md-counter="50" autofocus required @focus="clearErrorTitle"></md-input>
                                <span class="md-helper-text">Pflichtfeld</span>
                                <span class="md-error">Bitte vergeben Sie einen Titel.</span>
                            </md-field>
                            <md-field :class="messageError">
                                <label>Mangelbescheibung</label>
                                <md-textarea v-model="message" style="min-height: 150px" md-counter="500" required @focus="clearErrorMessage"></md-textarea>
                                <span class="md-helper-text">Pflichtfeld</span>
                                <span class="md-error">Bitte vergeben Sie eine Mangelbescheibung.</span>
                            </md-field>
                            <md-field :class="filesError">
                                <label>Anhänge</label>
                                <md-file v-model="files" multiple accept="image/png, image/jpeg" @md-change="filesChanged" @change="clearErrorFile"/>
                                <span class="md-error">Es können nur Bilder im Format .png oder .jpeg verwendet werden.</span>
                            </md-field>
                            <md-divider></md-divider>
                            <md-subheader>Für Rückfragen</md-subheader>
                            <md-field>
                                <md-icon>person</md-icon>
                                <label>Name</label>
                                <md-input v-model="name" @change="clearErrorTos"></md-input>
                            </md-field>
                            <md-field>
                                <md-icon>phone</md-icon>
                                <label>Telefonnummer</label>
                                <md-input v-model="phone" type="tel"  @change="clearErrorTos"></md-input>
                            </md-field>
                            <md-field :class="emailError">
                                <md-icon>email</md-icon>
                                <label>Email</label>
                                <md-input v-model="email" type="email" @focus="clearErrorEmail"  @change="clearErrorTos"></md-input>
                                <span class="md-error">Die angegebene Emailadresse ist nicht korrekt.</span>
                            </md-field>
                            <md-checkbox v-model="tos" class="md-primary" style="margin-bottom: 4px" @change="clearErrorTos">Ich akzeptiere die <a :href="tosText" target="_blank" @click.stop="toggleTos">Datenschutzerklärung</a></md-checkbox>
                            <md-checkbox v-model="shouldNotify" class="md-primary" style="margin-bottom: 4px" @change="clearErrorTos">Ich möchte über den Bearbeitungsstatus meiner Meldung informiert werden.</md-checkbox>
                            <span v-if="tosError" style="display: inline-flex; width: auto; position: relative; color: #ff1744; font-size: 12px">
                                Um persönliche Daten zu übertragen, akzeptieren Sie bitte die Datenschutzerklärung.
                            </span>
                        </form>
                    </md-card-content>

                    <md-card-actions style="margin-top: 12px">
                        <md-button class="md-primary" :disabled="lat === null && lon === null" @click="submitDialog">Mangel melden</md-button>
                    </md-card-actions>
                </md-card>
            </b-col>
            </hide-at>
            <b-col id="map_main" style="height: 100%; padding: 0px;  transition: margin-left .5s; overflow-y: hidden">
                <div style="position: absolute;
                width:100%;
                height:100%;
                top: 0; right: 0;
                bottom: 0; left: 0;"
                     id="map_container_1"
                     ref="map_container_1">
                    <hide-at breakpoint="mediumAndAbove">
                    <div style="z-index: 3; position: absolute;
                            bottom: 5px; right: 30px; padding-top: 1rem; padding-left: 1rem; padding-right: 1rem">
                        <md-button :disabled="lat===null && lon === null" class="md-dense md-raised md-primary" v-on:click="onButtonClicked">{{buttonText}}</md-button>
                    </div>
                    </hide-at>
                </div>
                <b-row v-if="showHelpText" class="m-0">
                    <hide-at breakpoint="small">
                    <b-col md="3" lg="4"></b-col>
                    </hide-at>
                    <b-col><md-card style="margin-top: 5px; z-index: 2">
                        <hide-at breakpoint="small">
                        <md-card-content>
                            Bitte klicken Sie in die Karte, um die Position des Mangels festzulegen.
                            Bestehende Mängel werden mit roten Punkten signalisiert.
                        </md-card-content>
                        </hide-at>
                        <hide-at breakpoint="mediumAndAbove">
                            <md-card-content>
                                Bitte tippen Sie in die Karte, um die Position des Mangels festzulegen.
                                Bestehende Mängel werden mit roten Punkten signalisiert.
                            </md-card-content>
                        </hide-at>
                        <md-dialog-actions>
                            <md-button class="md-primary" v-on:click="onHideHelpText">Verstanden</md-button>
                        </md-dialog-actions>
                    </md-card></b-col>
                    <hide-at breakpoint="small">
                    <b-col md="3" lg="4"></b-col>
                    </hide-at>
                </b-row>
            </b-col>
        </b-row>
        <md-dialog :md-active.synch="showDialog" @md-closed="gotoSetMarker" @md-clicked-outside="gotoSetMarker" style="transition-duration: .0s">
            <md-dialog-title>Mangel melden</md-dialog-title>
            <md-dialog-content>
                <form autocomplete="on">
                    <md-field :class="titleError">
                        <label>Titel</label>
                        <md-input v-model="title" md-counter="50" autofocus required @focus="clearErrorTitle"></md-input>
                        <span class="md-helper-text">Pflichtfeld</span>
                        <span class="md-error">Bitte vergeben Sie einen Titel.</span>
                    </md-field>
                    <md-field :class="messageError">
                        <label>Mangelbescheibung</label>
                        <md-textarea v-model="message" style="min-height: 150px" md-counter="500" required @focus="clearErrorMessage"></md-textarea>
                        <span class="md-helper-text">Pflichtfeld</span>
                        <span class="md-error">Bitte vergeben Sie eine Mangelbescheibung.</span>
                    </md-field>
                    <md-field :class="filesError">
                        <label>Anhänge</label>
                        <md-file v-model="files" multiple accept="image/png, image/jpeg" @md-change="filesChanged" @change="clearErrorFile"/>
                        <span class="md-error">Es können nur Bilder im Format .png oder .jpeg verwendet werden.</span>
                    </md-field>
                    <md-divider></md-divider>
                    <md-subheader>Für Rückfragen</md-subheader>
                    <md-field>
                        <md-icon>person</md-icon>
                        <label>Name</label>
                        <md-input v-model="name" @change="clearErrorTos"></md-input>
                    </md-field>
                    <md-field>
                        <md-icon>phone</md-icon>
                        <label>Telefonnummer</label>
                        <md-input v-model="phone" type="tel"  @change="clearErrorTos"></md-input>
                    </md-field>
                    <md-field :class="emailError">
                        <md-icon>email</md-icon>
                        <label>Email</label>
                        <md-input v-model="email" type="email" @focus="clearErrorEmail"  @change="clearErrorTos"></md-input>
                        <span class="md-error">Die angegebene Emailadresse ist nicht korrekt.</span>
                    </md-field>
                    <md-checkbox v-model="tos" class="md-primary" style="margin-bottom: 4px" @change="clearErrorTos">Ich akzeptiere die <a :href="tosText" target="_blank" @click.stop="toggleTos">Datenschutzerklärung</a></md-checkbox>
                    <md-checkbox v-model="shouldNotify" class="md-primary" style="margin-bottom: 4px" @change="clearErrorTos">Ich möchte über den Bearbeitungsstatus meiner Meldung informiert werden.</md-checkbox>
                    <span v-if="tosError" style="display: inline-flex; width: auto; position: relative; color: #ff1744; font-size: 12px">
                                Um persönliche Daten zu übertragen, akzeptieren Sie bitte die Datenschutzerklärung.
                            </span>
                </form>
            </md-dialog-content>
            <md-dialog-actions>
                <md-button class="md-primary" @click="cancleDialog">Abbrechen</md-button>
                <md-button class="md-primary" @click="submitDialog">Abschicken</md-button>
            </md-dialog-actions>
        </md-dialog>
        <md-dialog-confirm
                :md-active.sync="showTos"
                md-title="Datenschutzerklärung"
                :md-content="tosText"
                md-confirm-text="Zustimmen"
                md-cancel-text="Ablehnen"
                @md-cancel="onDeclienTos"
                @md-confirm="onAcceptTos"
                @md-clicked-outside="reshowDialog"
                @md-closed="reshowDialog"
        />
        <md-snackbar md-position="center" :md-active.sync="showSnackbar">
            <span>Der Mangel wurde erfolgreich gemeldet und über dessen Umsetzung wird in Ihrer Kommune entschieden.</span>
        </md-snackbar>
        <md-dialog :md-active.synch="showSelection" style="transition-duration: .0s" :md-close-on-esc="false" :md-click-outside-to-close="false">
            <md-dialog-title>Kommune wählen</md-dialog-title>
            <md-dialog-content>
                <form >
                    <md-field>
                        <label for="commune">Kommune</label>
                        <md-select v-model="commune" name="commune" id="commune">
                            <md-option v-for="item in communes" :value="item.id">{{item.value_2}}</md-option>
                        </md-select>
                    </md-field>
                    <span v-if="communeError" style="display: inline-flex; width: auto; position: relative; color: #ff1744; font-size: 12px">
                                Bitte wählen Sie eine Kommune.
                            </span>
                </form>
            </md-dialog-content>
            <md-dialog-actions>
                <md-button class="md-primary" @click="selectCommune">Auswahl bestätigen</md-button>
            </md-dialog-actions>
        </md-dialog>
    </b-col>
</template>

<script>

    import ZoomControl from 'mapbox-gl-controls/lib/zoom';
    import LanguageControl from 'mapbox-gl-controls/lib/language';
    import mapboxgl from 'mapbox-gl/dist/mapbox-gl';
    import {Server_URL, Server_URL_MAENGELMELDER, validateEmail} from "../shared/utils";
    import {showAt, hideAt} from 'vue-breakpoints'
    import { EventBus } from '../shared/eventbus';


    export default {
        name: "MaengelMelder",
        components: { hideAt, showAt },
        mounted() {
            this.breakpoints = {
                small: 744,
                medium: 1128,
                large: Infinity
            };
            this.commune = this.$route.query.commune;
            window.addEventListener('resize', this.handleResize);
            this.handleResize();
            mapboxgl.accessToken = 'pk.eyJ1Ijoic3ZlbnBldGVyc2VuIiwiYSI6ImNqc3Z0YW82dDBhbDE0NXFpOGRzOXI4NWsifQ.Sq1nJiC3uKfA5yfYN8wR9w';
            this.map = new mapboxgl.Map({
                container: 'map_container_1',
                style: 'mapbox://styles/mapbox/outdoors-v11',
                center: [10.244990, 50.943359],
                zoom: 6,
                minZoom: 5,
                maxPitch: 0,
                attributionControl: false
            });

            this.map.addControl(new ZoomControl(), 'bottom-right');
            const languageControl = new LanguageControl({
                language: 'de',
            });
            this.map.addControl(languageControl);
                this.geolocate = new mapboxgl.GeolocateControl({
                    positionOptions: {
                        enableHighAccuracy: true
                    },
                    // When active the map will receive updates to the device's location as it changes.
                    trackUserLocation: true,
                    // Draw an arrow next to the location dot to indicate which direction the device is heading.
                    showUserHeading: true,
                    fitBoundsOptions: {maxZoom: 18}
                });

                this.geolocate.on('geolocate', function (userlocation) {
                    this.lastKnownLocation = userlocation.coords;
                });
                this.map.addControl(
                    this.geolocate, "bottom-right"
                );

            this.map.addControl(new mapboxgl.AttributionControl(), "top-right");

            this.marker = null;
            this.geojson = {};
            this.map.on('load', this.mapLoad);
            this.showLoader();
            this.$http.get(
                Server_URL_MAENGELMELDER + '/mm/data/settings/'+this.$route.params.id
            ).then(this.responseOkGet, this.responseError)

        },
        beforeDestroy () {
            window.removeEventListener('resize', this.handleResize);
        },
        data() {
            return {
                visible: true,
                mapLoaded: false,
                requestLoaded: false,
                markers: {},
                markersOnScreen: {},
                first_load: true,
                bounds: [],
                lastKnownLocation: {},
                buttonText: "Mangel erfassen",
                lat: null,
                lon: null,
                showDialog: false,
                title: "",
                message: "",
                email: "",
                phone: "",
                name: "",
                tos: false,
                files: "",
                fileList: [],
                showTos: false,
                tosText: "",
                currentMangelId: "",
                currentMangel: {},
                currentBreakpoint: '',
                showHelpText: true,
                titleInvalid: false,
                messageInvalid: false,
                filesInvalid: false,
                emailInvalid: false,
                tosInvalid: false,
                showSnackbar: false,
                communes: [],
                commune: "",
                perimeters: [],
                suiteName: "",
                showSelection: false,
                communeInvalid: false,
                shouldNotify: false,
                shouldShowDirectly: false,
            }
        },
        computed: {
            titleError () {
                return {
                    'md-invalid': this.titleInvalid
                }
            },
            messageError () {
                return {
                    'md-invalid': this.messageInvalid
                }
            },
            filesError () {
                return {
                    'md-invalid': this.filesInvalid
                }
            },
            emailError () {
                return {
                    'md-invalid': this.emailInvalid
                }
            },
            tosError () {
                return this.tosInvalid;
            },
            communeError () {
                return this.communeInvalid;
            },
        },
        watch: {
            'suiteName': function(newVal, oldVal) {
                if (newVal !== "" && newVal !== null && newVal !== undefined) {
                    EventBus.$emit('suite-name', newVal);
                }
            },
            'commune': function(newVal, oldVal) {
                this.communeInvalid = false;
            },
        },
        methods: {
            selectCommune() {
              if (this.commune === "" || this.commune === null || this.commune === undefined) {
                  this.communeInvalid = true;
                  return;
              }
                for (let i = 0; i < this.communes.length; i++) {
                    if (this.communes[i].id === this.commune) {
                        this.suiteName = this.communes[i].value_2;
                    }
                }
                for (let i = 0; i < this.perimeters.length; i++) {
                    if (this.perimeters[i].value_2 === this.commune) {
                        this.bounds = [];
                        let splits = this.perimeters[i].value_4.split("||");
                        for (let j = 0; j < splits.length; j++) {
                            let split2 = splits[j].split("|");
                            this.bounds.push([parseFloat(split2[0]), parseFloat(split2[1])]);
                        }
                    }
                }
                this.showLoader();
                this.$http.get(
                    Server_URL_MAENGELMELDER + '/mm/data/defects/'+this.$route.params.id+"?commune="+this.commune
                ).then(this.responseOkGetGeoJson, this.responseError)
                this.showSelection = false;
            },
            showLoader() {
                this.loader = this.$loading.show();
            },
            hideLoader() {
                if (this.loader !== undefined) {
                    this.loader.hide();
                    this.loader = undefined;
                }
            },
            responseError(response) {
                this.hideLoader();
                if (response.status === 401) {
                    console.log(response);
                } else {
                    console.log(response);
                }
            },
            responseOkGet(response) {
                if (response.status === 200) {
                    let settings = response.body.data;
                    for (let i = 0; i < settings.length; i++) {
                        if (settings[i].id === "data_protection") {
                            this.tosText = settings[i].value_4;
                        }
                        if (settings[i].value_1 === "commune") {
                            this.communes.push(settings[i]);
                        }
                        if (settings[i].value_1 === "bounds") {
                            this.perimeters.push(settings[i]);
                        }
                    }
                    if (this.communes.length === 1) {
                        this.commune = this.communes[0].id;
                    }
                    if (this.commune !== undefined && this.commune !== "") {
                        for (let i = 0; i < this.communes.length; i++) {
                            if (this.communes[i].id === this.commune) {
                                this.suiteName = this.communes[i].value_2;
                            }
                        }
                        for (let i = 0; i < this.perimeters.length; i++) {
                            if (this.perimeters[i].value_2 === this.commune) {
                                this.bounds = [];
                                let splits = this.perimeters[i].value_4.split("||");
                                for (let j = 0; j < splits.length; j++) {
                                    let split2 = splits[j].split("|");
                                    this.bounds.push([parseFloat(split2[0]), parseFloat(split2[1])]);
                                }
                            }
                        }
                    }
                    if (this.commune !== undefined && this.commune !== "") {
                        this.$http.get(
                            Server_URL_MAENGELMELDER + '/mm/data/defects/'+this.$route.params.id+"?commune="+this.commune
                        ).then(this.responseOkGetGeoJson, this.responseError)
                    } else {
                        this.hideLoader();
                        this.showSelection = true;
                    }
                } else {
                    console.log(response);
                }
            },
            responseOkGetGeoJson(response) {
                this.hideLoader();
                if (response.status === 200) {
                    this.geojson = response.body.data.geo_json;
                    this.shouldShowDirectly = response.body.data.should_show_directly;

                        this.requestLoaded = true;
                    if (this.mapLoaded === true) {
                        this.addLayers();
                    }
                } else {
                    console.log(response);
                }
            },
            responseOkCreate(response) {
                if (response.status === 200) {
                    this.currentMangelId = response.body.data;
                    if (this.fileList !== null && this.fileList.length > 0 ) {
                        let file = this.fileList.shift();
                        let formData = new FormData();
                        formData.append('file', file);
                        this.$http.post(
                            Server_URL_MAENGELMELDER + '/mm/data/defect_image/' + this.$route.params.id + "?defect_id="+this.currentMangelId,
                            formData,
                            {
                                headers: {
                                    'Content-Type': 'multipart/form-data'
                                }
                            }
                        ).then(this.responseOkSendImage, this.responseError);
                    } else {
                        this.$http.post(
                            Server_URL_MAENGELMELDER + '/mm/data/defect_finish/' + this.$route.params.id + "?defect_id="+this.currentMangelId,
                        ).then(this.responseOkFinish, this.responseError);
                    }
                } else {
                    console.log(response);
                }
            },
            responseOkSendImage(response) {
                //this.hideLoader();
                if (response.status === 200) {
                    if (this.fileList !== null && this.fileList.length > 0 ) {
                        let file = this.fileList.shift();
                        let formData = new FormData();
                        formData.append('file', file);
                        this.$http.post(
                            Server_URL_MAENGELMELDER + '/mm/data/defect_image/' + this.$route.params.id + "?defect_id="+this.currentMangelId,
                            formData,
                            {
                                headers: {
                                    'Content-Type': 'multipart/form-data'
                                }
                            }
                        ).then(this.responseOkSendImage, this.responseError);
                    } else {
                        this.$http.post(
                            Server_URL_MAENGELMELDER + '/mm/data/defect_finish/' + this.$route.params.id + "?defect_id="+this.currentMangelId,
                        ).then(this.responseOkFinish, this.responseError);
                    }
                } else {
                    console.log(response);
                }
            },
            responseOkFinish(response) {
                if (response.status === 200) {
                        this.showSnackbar = true;
                        if (this.shouldShowDirectly) {
                            let feature = {
                                type: "Feature",
                                geometry: {
                                    type: "Point",
                                    coordinates: [this.currentMangel.lon, this.currentMangel.lat]
                                },
                                properties: {
                                    id: this.currentMangelId,
                                    title: this.currentMangel.title,
                                    message: this.currentMangel.message,
                                    files: "files",
                                    create_date: null
                                }
                            };
                            this.geojson.features.push(feature);
                            this.map.getSource('unclustered-source').setData(this.geojson);
                        }
                        this.clearMarker();
                        this.cancleDialog();
                  this.hideLoader();
                } else {
                    console.log(response);
                  this.hideLoader();
                }
            },
            createLayer(layers) {

                return {
                    id:  'normal-point',
                    type: 'circle',
                    source:  'unclustered-source',
                    filter:  ["boolean", true],
                    paint: {
                        'circle-color': 'red',
                        'circle-radius': 10,
                        'circle-stroke-width': 1,
                        'circle-stroke-color': '#fff'
                    },
                }
            },
            mapLoad() {
                this.mapLoaded = true;
                if (this.requestLoaded === true) {
                    this.addLayers();
                }
                this.map.on('mouseenter', 'unclustered-point', () => {
                    this.map.getCanvas().style.cursor = 'pointer';
                });
                this.map.on('mouseleave', 'unclustered-point', () => {
                    this.map.getCanvas().style.cursor = '';
                });
                this.map.on('mouseenter', 'normal-point', () => {
                    this.map.getCanvas().style.cursor = 'pointer';
                });
                this.map.on('mouseleave', 'normal-point', () => {
                    this.map.getCanvas().style.cursor = '';
                });
                this.map.on('click', 'normal-point', this.onMarkerClicked);
                this.map.on('click', this.onMapClicked);
            },
            addLayers() {
                this.map.addSource('unclustered-source', {
                    type: 'geojson',
                    data: this.geojson,
                });
                this.map.addLayer(this.createLayer());
                if (this.first_load) {
                    this.first_load = false;
                    setTimeout(() => {
                        this.map.resize();
                        if (this.bounds.length == 4) {
                            this.map.fitBounds(this.getBounds(), {padding: 20, duration: 1000});
                        }
                        if (this.currentBreakpoint === "small") {
                            setTimeout(() => {
                                this.geolocate.trigger();
                            }, 1100);
                        }
                    });
                }
            },
            getBounds() {
                let bounds = new (mapboxgl.LngLatBounds);
                if (this.bounds.length > 0) {
                    for (let i = 0; i < this.bounds.length; i++) {
                        bounds.extend(this.bounds[i])
                    }
                }
                return bounds;
            },
            onMapClicked(e) {
                if (e.defaultPrevented) {
                    return;
                }
                this.lat = e.lngLat.lat;
                    this.lon = e.lngLat.lng;

                    if (this.marker === null) {
                        let el = document.createElement('div');
                        el.className = 'marker';

                        this.marker = new mapboxgl.Marker({
                           element: el,
                            anchor: 'center',
                        })
                            .setLngLat([this.lon, this.lat])
                            .addTo(this.map);
                        this.map.resize();
                    } else {
                        this.marker.setLngLat([this.lon, this.lat])
                    }
            },
            clearMarker() {
              if (this.marker !== undefined && this.marker !== null) {
                  this.marker.remove();
                  this.marker = null;
                  this.lat = null;
                  this.lon = null;
              }
            },
            onMarkerClicked(e) {
                e.preventDefault();
                let coordinates = e.features[0].geometry.coordinates.slice();
                let props = e.features[0].properties;
                new mapboxgl.Popup()
                    .setLngLat(coordinates)
                    .setHTML("<strong class='popup-header'>" + props.title + "</strong><p class='popup-content'>" + props.message + "</p>")
                    .addTo(this.map);
                /*let ComponentClass = Vue.extend(MapPopup);
                let instance = new ComponentClass();
                let condition = "unklar";
                for (let i = 0; i < this.layer_props.layer_condition.length; i++) {
                    let cur = this.layer_props.layer_condition[i];
                    if (cur.layer_value === props.condition) {
                        condition = cur.layer_name;
                        break;
                    }
                }
                let splits = props.next_control.split("-");
                instance.$slots.header = [ props.tree_number ];
                instance.$slots.tour = [ props.tour ];
                instance.$slots.condition = [ condition ];
                instance.$slots.next_control = [ splits[2]+"."+splits[1]+"."+splits[0] ];
                instance.$slots.action_required = [ props.action_required ? "ja" : "nein"  ];

                instance.$mount();
                instance.$on('goto-tree', () => { this.gotoTree(props.tree_id) });
                new mapboxgl.Popup()
                    .setLngLat(coordinates).setDOMContent(instance.$el).addTo(this.map);

                 */
            },
            onButtonClicked() {
                this.showDialog = true;
            },
            gotoSetMarker() {
                this.cancleDialog();
            },
            toggleTos() {
                //this.showDialog = false;
                //this.showTos = true;
                this.$refs.to_tos.click();
            },
            onAcceptTos() {
                this.reshowDialog();
                this.tos = true;
                this.clearErrorTos();
            },
            onDeclienTos() {
                this.reshowDialog();
              this.tos = false;
            },
            reshowDialog() {
                if (this.currentBreakpoint === "small") {
                    this.showDialog = true;
                }
            },
            onHideHelpText() {
                this.showHelpText = false;
            },
            cancleDialog() {
                this.showDialog = false;
                this.title = "";
                this.message = "";
                this.email ="";
                this.phone = "";
                this.name = "";
                this.tos = false;
                this.files = "";
                this.fileList = [];
                this.currentMangelId = null;
                this.shouldNotify = false;
            },
            submitDialog() {

                if (this.checkInputs()) {
                    return
                }

                let data = {
                    title: this.title,
                    message: this.message,
                    should_notify: this.shouldNotify,
                    name: this.name,
                    phone_number: this.phone,
                    email: this.email,
                    lat: this.lat,
                    lon: this.lon,
                };
                this.currentMangel = data;
                this.showLoader();
                this.$http.post(
                    Server_URL_MAENGELMELDER + '/mm/data/defect/'+this.$route.params.id+"?commune="+this.commune,data
                ).then(this.responseOkCreate, this.responseError);
            },
            filesChanged(e) {
                this.fileList = [];
                if (e.length > 0) {
                    for (let i = 0; i < e.length; i++) {
                        this.fileList.push(e.item(i));
                    }
                }
            },
            handleResize () {
                const clientWidth = window.innerWidth;
                if (clientWidth < this.breakpoints.small) {
                    this.currentBreakpoint = 'small';
                } else if (clientWidth < this.breakpoints.medium) {
                    this.currentBreakpoint = 'medium';
                } else if (clientWidth <= this.breakpoints.large) {
                    this.currentBreakpoint = 'large';
                }
            },
            checkInputs() {
                let invalid = false;

                if (this.title === "" || this.title.trim() === "") {
                    this.titleInvalid = true;
                    invalid = true;
                } else {
                    this.titleInvalid = false;
                }

                if (this.message === "" || this.message.trim() === "") {
                    this.messageInvalid = true;
                    invalid = true;
                } else {
                    this.messageInvalid = false;
                }

                if (this.email !== "" && !validateEmail(this.email)) {
                    this.emailInvalid = true;
                    invalid = true;
                } else {
                    this.emailInvalid = false;
                }

                if (( this.email.trim() !== ""
                    || this.name.trim() !== "" || this.phone.trim() !== "") && !this.tos ) {
                    this.tosInvalid = true;
                    invalid = true;
                } else {
                    this.tosInvalid = false;
                }
                let fileInvalid = false;
                if (this.fileList !== null && this.fileList.length > 0) {
                    for (let i = 0; i < this.fileList.length; i++) {
                        let current =  this.fileList[i];
                        if (current.type !== "image/png" && current.type !== "image/jpeg" && current.type !== "image/jpg") {
                            fileInvalid = true;
                            invalid = true;
                            break;
                        }
                    }
                }
                this.filesInvalid = fileInvalid;

                return invalid;
            },
            clearErrorTitle() {
                this.titleInvalid = false;
            },
            clearErrorMessage() {
                this.messageInvalid = false;
            },
            clearErrorFile() {
                this.filesInvalid = false;
            },
            clearErrorEmail() {
                this.emailInvalid = false;

            },
            clearErrorTos() {
                if (this.tos === true) {
                    this.tosInvalid = false;
                } else if (this.email.trim() === "" && this.name.trim() === "" && this.phone.trim() === "") {
                    this.tosInvalid = false;
                }
            },
        },
    }
</script>

<style>

    .marker {
        background-image: url('../../public/mangel_marker.png');
        background-size: cover;
        width: 35px;
        height: 35px;
        border-radius: 50%;
        cursor: pointer;
        z-index: 1;
    }

    .black {
        color: black;
    }
    .legend {
        box-shadow: 0 1px 4px rgba(0, 0, 0, .3);
        -webkit-box-shadow: 0 1px 4px rgba(0, 0, 0, .3);
        -moz-box-shadow: 0 1px 4px rgba(0, 0, 0, .3);
        border-radius: 4px;
    }

    .sidebar2 {
        visibility: hidden;
        width: 0;
        position: absolute;
        z-index: 1 !important;
        overflow-x: hidden;
        -webkit-transition: 0.5s;
        transition: 0.5s;
        -moz-transition: 0.5s;
        padding: 0;
        top: 50px;
        -webkit-transition-property: width, visibility;
        transition-property: width, visibility;
        -moz-transition-property: width, visibility;
        -webkit-transition-timing-function: ease;
        transition-timing-function: ease;
        -moz-transition-timing-function: ease;
    }

    .mapboxgl-ctrl-top-left {
        display: flex;
        display: flex;
        display: -moz-flex;
        display: -webkit-flex;
        display: -o-flex;
    }

    .mapboxgl-ctrl-top-left .mapboxgl-ctrl {
        display: flex;
        display: flex;
        display: -moz-flex;
        display: -webkit-flex;
        display: -o-flex;
    }
    .mapboxgl-ctrl-top-left .mapboxgl-ctrl-group button+button {
        border-left: 1px solid #ddd;
        border-top: none;
    }

    .my-custom-control {
        color: #f00;
        background: #000;
        padding: 8px;
        border-radius: 4px;
        margin: 8px;
    }
    .mapboxgl-popup {
        max-width: 600px !important;
    }
    .mapboxgl-popup-close-button {
        font-size: 20px;
    }

    .md-button.md-theme-default.md-raised[disabled] {
        background-color: rgba(255, 255, 255, 1) !important;
        color: rgba(0,0,0,0.5) !important;
    }

    .popup-header {
        -webkit-text-size-adjust: 100%;
        -ms-text-size-adjust: 100%;
        -moz-osx-font-smoothing: grayscale;
        -webkit-font-smoothing: antialiased;
        font-family: Roboto,Noto Sans,-apple-system,BlinkMacSystemFont,sans-serif;
        margin: 8px;
    }
    .popup-content {
        -webkit-text-size-adjust: 100%;
        -ms-text-size-adjust: 100%;
        -moz-osx-font-smoothing: grayscale;
        -webkit-font-smoothing: antialiased;
        font-family: Roboto,Noto Sans,-apple-system,BlinkMacSystemFont,sans-serif;
        margin: 8px;
    }

</style>

<style scoped>
    @import '../../node_modules/vue-material/dist/vue-material.min.css';
    @import '../../node_modules/vue-material/dist/theme/default.css';

    .hoverable-icon:hover {
        cursor: pointer;
    }

</style>
